import classNames from 'classnames';
import React from 'react';
import * as styles from './Badge.module.scss';
import SVGIcon from './SVGIcon';

export type BadgeColor = 'yellow' | 'blue' | 'red' | 'gray' | 'green' | 'pink';

interface BadgeProps {
  children: React.ReactNode;
  color?: BadgeColor;
  onClick?: () => void;
  className?: string;
  inline?: boolean;
  icon?: React.ReactNode | null;
}

const Badge = ({
  children,
  color,
  onClick,
  className,
  inline = true,
  icon,
}: BadgeProps) => {
  const baseClassNames = classNames(
    className,
    styles.badge,
    color && styles[color],
    {
      [styles.inline]: inline,
      [styles.hasIcon]: !!icon,
    },
  );

  if (onClick) {
    return (
      <button
        className={classNames(baseClassNames, styles.badgeButton)}
        onClick={onClick}
        type="button"
      >
        {icon}
        <div className={styles.content}>{children}</div>
      </button>
    );
  }

  return (
    <div className={baseClassNames}>
      {icon}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

interface IconProps {
  className?: string;
  children: string | null;
}

Badge.Icon = ({ className, children }: IconProps) => (
  <SVGIcon size={12.5} className={classNames(styles.icon, className)}>
    {children}
  </SVGIcon>
);

export default Badge;
